<template>
  <div class="app">
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Corporate-Identification') }}  </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search3"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                slot="activator"
                @click="insertSirketOpen()"
                flat
              >
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Company')}) }} </span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Company')}) }}</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headersSirket"
        :rows-per-page-items="[50, 100]"
        :loading="progress"
        :items="items"
        :search="search3"
      >
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.CompanyID }}</td>
            <td class="text-xs-left">{{ props.item.CompanyShortName }}</td>
            <td class="text-xs-left">{{ props.item.CompanyLongName }}</td>
            <td class="justify-end align-center full-heigth layout px-0">
              <v-btn
                v-if="sayfayetki.Update"
                @click="editDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="info">search</v-icon>
              </v-btn>
              <v-btn
                v-if="sayfayetki.Delete"
                @click="deleteDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="warning">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDataDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">Şirket Düzenle</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field
            v-model="sirketLoadData.CompanyShortName"
            :label="$t('Short-Name')"
          ></v-text-field>
          <v-text-field
            v-model="sirketLoadData.CompanyLongName"
            :label="$t('Long-Name')"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="editDataDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="UpdateSirket()"> {{ $t('Update') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="insertDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">{{ $t('Add-v2', { value: $t('Company')}) }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field
            v-model="sirketData.CompanyShortName"
            :label="$t('Short-Name')"
          ></v-text-field>
          <v-text-field
            v-model="sirketData.CompanyLongName"
            :label="$t('Long-Name')"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="insertDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="insertSirket()"> {{ $t('save_button') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text">Şirket Sil</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="deleteSirket()">  {{ $t('Delete') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import auth from "@/api/auth";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  data() {
    return {
      loadingvmodel: false,
      editDataDialog: false,
      insertDialog: false,
      deleteDialog: false,
      deleteData: 0,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      headersSirket: [
        {
          text: "ID",
          value: "CompanyID",
          align: "left",
        },
        {
          text: this.$t('Short-Name'),
          value: "CompanyShortName",
          align: "left",
        },
        {
          text: this.$t('Long-Name'),
          value: "CompanyLongName",
          align: "left",
        },
        {
          text: this.$t('Process'),
          value: "İslem",
          align: "right",
        },
      ],
      sirketData: {
        CompanyID: 0,
        CompanyShortName: null,
        CompanyLongName: null,
        UserID: 0,
      },
      sirketLoadData: {
        CompanyID: 0,
        CompanyShortName: null,
        CompanyLongName: null,
        UserID: 0,
      },
      loading: false,
      progress: false,
      items: [],
      search3: "",
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
    };
  },
  components: {
    tool,
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
  methods: {
    deleteDialogOpen(val) {
      this.deleteDialog = true;
      this.deleteData = val;
    },
    deleteSirket() {
      this.loadingvmodel = true;
      var params = {
        CompanyID: this.deleteData.MuhasebeSirketNo,
        UserID: this.credentials.UserID,
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCompanyDelete",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.text1 = this.$t('Update-completed');
            this.snackbar = true;
            this.deleteDialog = false;
            this.loadingvmodel = false;
            this.getSirketList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCompanyDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCompanyDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    insertSirket() {
      this.loadingvmodel = true;
      this.sirketData.UserID = this.credentials.UserID;

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCompanySave",
          this.sirketData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.text1 = this.$t('Update-completed');
            this.snackbar = true;
            this.insertDialog = false;
            this.loadingvmodel = false;

            this.getSirketList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCompanySave";
              this.snackbar = true;
              this.insertDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCompanySave";
              this.snackbar = true;
              this.insertDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    insertSirketOpen() {
      this.sirketData.CompanyShortName = null;
      this.sirketData.CompanyLongName = null;
      this.insertDialog = true;
    },
    UpdateSirket() {
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCompanySave",
          this.sirketLoadData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.text1 = this.$t('Update-completed');
            this.snackbar = true;
            this.getSirketList();
            this.editDataDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCompanyLoad";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCompanyLoad";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    editDialogOpen(val) {
      var params = {
        CompanyID: val.CompanyID,
        UserID: val.UserID,
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCompanyLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.sirketLoadData = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCompanyLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingCompanyLoad";
              this.snackbar = true;
            }
          }
        );
      this.editDataDialog = true;
    },
    getSirketList() {
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCompanyList",
          null,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.items = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.getSirketList();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>